import { InternalApiClient } from '../lib/InternalApiClient';

/**
 * Update the authenticated user's email via the Control Room API.
 *
 * @param {string} userId - id of the current user (unused; auth comes from Bearer token)
 * @param {string} email - the desired email address
 */
export async function changeEmail(userId, email) {
  const apiClient = new InternalApiClient();

  return apiClient.users.changeEmail(email);
}
